import request from '@/utils/requests.js'

// Admin API Services
export const adminService = {
  // Dashboard Admin
  async getDashboardStats() {
    return request({
      url: '/admin/dashboard',
      method: 'get'
    })
  },

  // New Metrics Endpoints
  async getAdminMetrics(params = {}) {
    return request({
      url: '/admin/metrics',
      method: 'get',
      params
    })
  },

  async getExamTrends(months = 6) {
    return request({
      url: '/admin/metrics/trends',
      method: 'get',
      params: { months }
    })
  },

  async getUploadHeatmap(days = 30) {
    return request({
      url: '/admin/metrics/heatmap',
      method: 'get',
      params: { days }
    })
  },

  async getSystemAlerts(params = {}) {
    return request({
      url: '/admin/alerts',
      method: 'get',
      params
    })
  },

  // Export functionality
  async exportData(dataType, startDate = null, endDate = null) {
    const params = { data_type: dataType }
    if (startDate) params.start_date = startDate
    if (endDate) params.end_date = endDate

    return request({
      url: '/admin/export/csv',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },

  // System Status
  async getSystemStatus() {
    return request({
      url: '/admin/status',
      method: 'get'
    })
  },

  async getSystemOverview() {
    return request({
      url: '/admin/status/overview',
      method: 'get'
    })
  },

  async getOrthancStatus() {
    return request({
      url: '/admin/status/orthanc',
      method: 'get'
    })
  },

  async getDatabaseStatus() {
    return request({
      url: '/admin/status/database',
      method: 'get'
    })
  },

  async getRedisStatus() {
    return request({
      url: '/admin/status/redis',
      method: 'get'
    })
  },

  async getHl7Status() {
    return request({
      url: '/admin/status/hl7',
      method: 'get'
    })
  },

  // User Management
  async createUser(userData) {
    return request({
      url: '/users/',
      method: 'post',
      data: userData
    })
  },

  async listUsers(filters = {}) {
    return request({
      url: '/users/',
      method: 'get',
      params: filters
    })
  },

  async getUserById(userId) {
    return request({
      url: `/users/${userId}`,
      method: 'get'
    })
  },

  async updateUser(userId, userData) {
    return request({
      url: `/users/${userId}`,
      method: 'put',
      data: userData
    })
  },

  async toggleUserStatus(userId) {
    return request({
      url: `/users/${userId}/toggle-status`,
      method: 'put'
    })
  },

  async activateUser(userId) {
    return request({
      url: `/users/${userId}/activate`,
      method: 'patch'
    })
  },

  async deactivateUser(userId) {
    return request({
      url: `/users/${userId}/deactivate`,
      method: 'patch'
    })
  },

  async updateUserRole(userId, newRole) {
    return request({
      url: `/users/${userId}/role`,
      method: 'put',
      params: { new_role: newRole }
    })
  },

  async resetUserPassword(userId, newPassword = null) {
    const data = newPassword ? { new_password: newPassword } : {};
    return request({
      url: `/users/${userId}/reset-password`,
      method: 'patch',
      data
    })
  },

  async deleteUser(userId) {
    return request({
      url: `/users/${userId}`,
      method: 'delete'
    })
  }
}
